"use client"

import { useEffect, useState } from "react"
import styles from "./loading-view.module.css"

export default function LoadingView() {
  const [loadingProgress, setLoadingProgress] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          return 100
        }
        return prev + 5
      })
    }, 150)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <span className={styles.easy}>#Easy</span>
            <span className={styles.pos}>POS</span>
          </div>
          <div className={styles.loadingText}>Loading {loadingProgress}%</div>
        </div>
      </div>
    </div>
  )
}
